/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class LevenhukService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any Success
     * @throws ApiError
     */
    public getApiLevenhukFeedXml(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Levenhuk/feed.xml',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public getApiLevenhukFeedShoptetXml(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Levenhuk/feed-shoptet.xml',
        });
    }

    /**
     * @returns any Success
     * @throws ApiError
     */
    public getApiLevenhukFeedRaisedXml(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/Levenhuk/feed-raised.xml',
        });
    }

}
